const ReportReducer = (state = {
    storageStatusReport: { Data: [], TotalCount: 0 }, invTurnoverReport: { Data: [], TotalCount: 0 },
    stgStatusReportFilters: {}, turnoverReportFilters: {}, invoiceDetailsFilters: null, invoiceDetailsReport: null, storageValueReport: null
}, action) => {
    switch (action.type) {
        case "STG_STATUS_REPORT":
            return {
                ...state,
                storageStatusReport: action.data
            }
        case "STG_STATUS_FILTERS":
            return {
                ...state,
                stgStatusReportFilters: action.data
            }
        case "INVENTORY_TURNOVER_FILTERS":
            return {
                ...state,
                turnoverReportFilters: action.data
            }
        case "INVENTORY_TURNOVER_REPORT":
            return {
                ...state,
                invTurnoverReport: action.data
            }
        case "INVOICE_DETAILES_FILTERS":
            return {
                ...state,
                invoiceDetailsFilters: action.data
            }
        case "INVOICE_DETAILS_REPORT":
            return {
                ...state,
                invoiceDetailsReport: action.data
            }
        case "STORAGE_VALUE_REPORT":
            return {
                ...state,
                storageValueReport: action.data
            }
        default:
            return state;
    }
}
export default ReportReducer;
